export default __webpack_public_path__ + "static/Remove-Background-92b5279a775109237091ff6c41c53baf.webm";